import React from 'react';

import userIcon from '../../../assets/icons/header/oneInformBar/user.svg';

interface UserProps {
    loggedIn: boolean;
    userName: string;
    onClick: () => void;
}

const User: React.FC<UserProps> = ({ loggedIn, userName, onClick }) => {
    return (
        <div
            onClick={!loggedIn ? onClick : undefined}
            className={`flex items-center pl-[10px] md:pl-[17px] h-[20px] cursor-pointer hover:text-gray-200 text-white ${loggedIn ? 'pr-[10px] md:pr-[17px] border-r border-gray-600' : 'pr-0'}`}
        >
            <img src={userIcon} alt="User" className="w-6 h-6 md:w-[20px] md:h-[20px] md:mr-[4px]" />
            <span className="hidden md:inline">
                {loggedIn ? `Welcome ${userName}` : 'Log in'}
            </span>
        </div>
    );
};

export default User;
